import { configureStore } from '@reduxjs/toolkit'
import reducers from './reducers'

const initialState = {}

const store = configureStore({
    reducer: reducers,
    preloadedState: initialState,
})

export default store
